/* tslint:disable:all */
import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {ComponentBase} from '../../core/entities/component-base';


@Component({
  templateUrl : './default.layout.component.html',
  styleUrls : ['./default.layout.component.scss']
})
export class DefaultLayoutComponent extends ComponentBase implements OnInit, OnDestroy {



  ngOnDestroy() {

  }

  ngOnInit() {

  }

  public get sidenavMode(): string {
   return null;
  }

  sidenavToggle(opened: boolean) {

  }

  toggleHover(isHovering: boolean) {

  }

}



// WEBPACK FOOTER //
// ./src/app/layout/default/default.layout.component.ts